"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.concat.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["className", "placement", "error", "dark", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// 气泡放置的位置转成箭头的方向
var placementToDirection = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top'
};

// 获取箭头的位置
function getArrowPlacement(placement) {
  var _placement$split = placement.split('-'),
    _placement$split2 = (0, _slicedToArray2.default)(_placement$split, 2),
    direction = _placement$split2[0],
    align = _placement$split2[1];
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('bubble');
  return ["".concat(prefixCls, "--").concat(placementToDirection[direction]), align ? "".concat(prefixCls, "--").concat(align) : null];
}
var Content = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    placement = props.placement,
    error = props.error,
    dark = props.dark,
    children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('bubble');
  var _getArrowPlacement = getArrowPlacement(placement),
    _getArrowPlacement2 = (0, _slicedToArray2.default)(_getArrowPlacement, 2),
    directionCls = _getArrowPlacement2[0],
    alignCls = _getArrowPlacement2[1];
  var darkCls = dark ? "".concat(prefixCls, "--dark") : '';
  var errorCls = error ? "".concat(prefixCls, "--error") : '';
  var classes = (0, _classnames.default)(prefixCls, className, directionCls, alignCls, darkCls, errorCls);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    ref: ref
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__inner")
  }, children));
});
Content.defaultProps = {
  placement: 'top'
};
var _default = exports.default = Content;